// src/components/layout.jsx

import { useSeekaAnonId } from '@seeka-labs/converge-react';
import { useEffect } from 'react';
import Helmet from 'react-helmet';
import { getUTMParameters } from '../utils/utmUtils';
import { Footer } from './footer';
import Header from './header';
import { SkipNavContent, SkipNavLink } from './skip-nav';

export function Layout({ children, uniqueId }) {
  const anonId = useSeekaAnonId();
  const methods = { setValue: (name, value) => sessionStorage.setItem(name, value) };

  useEffect(() => {
    getUTMParameters(methods);

    if (anonId) {
      const customSessionId = `custom-session-${Date.now()}`;
      const urlParts = window.location.pathname.split('/').filter(Boolean);
      const customPageId = urlParts[urlParts.length - 1] || 'home';
      const customId = anonId;

      const setClarityTags = () => {
        if (window.clarity) {
          // console.log('Setting Clarity identify with (layout):', {
          //   customId,
          //   customSessionId,
          //   customPageId,
          //   anonId,
          // });
          window.clarity('identify', customId, customSessionId, customPageId, customId);
          window.clarity('set', 'seekaId', customId);
          if (uniqueId) {
            // console.log('Setting Clarity tag uniqueFormSubmissionId with:', uniqueId);
            window.clarity('set', 'uniqueFormSubmissionId', uniqueId);
          }
        } else {
          console.error('Clarity is not available on window object');
        }
      };

      // Check if Clarity is available, and retry if not
      const checkClarityAvailability = () => {
        if (window.clarity) {
          setClarityTags();
        } else {
          console.warn('Clarity not available yet, retrying...');
          setTimeout(checkClarityAvailability, 500); // Retry after 500ms
        }
      };

      checkClarityAvailability();
    }
  }, [anonId, uniqueId]);

  return (
    <div>
      <Helmet>
        <link
          href="https://db.onlinewebfonts.com/c/03d5b20d124cd26dc873bd4a8e42313e?family=SuisseIntl-Light"
          rel="stylesheet"
          type="text/css"
        />
        <link
          href="https://db.onlinewebfonts.com/c/c446362802681bacaacbad0f39bfc1a5?family=SuisseIntl-Medium"
          rel="stylesheet"
          type="text/css"
        />
        <link
          href="https://db.onlinewebfonts.com/c/d1a580023d40c546276decde1c711e60?family=SuisseIntl-Bold"
          rel="stylesheet"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      </Helmet>
      <SkipNavLink />
      <Header />
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </div>
  );
}
